import { useEffect, useState } from "react";

const NAV_LINKS = [
  { label: "首页", href: "#home" },
  { label: "今日炸点", href: "#today" },
  { label: "栏目瓜田", href: "#columns" },
  { label: "事件盘点", href: "#feed" },
  { label: "全网围观榜", href: "#ranking" },
  { label: "吃瓜锦囊", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [live, setLive] = useState(true);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    const timer = window.setInterval(() => setLive((v) => !v), 1800);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.clearInterval(timer);
    };
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur-md shadow-[0_1px_0_rgba(33,29,24,0.06)]" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-[72px] w-full items-center justify-between px-4 md:px-6">
        <a href="#home" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg leading-none" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="text-lg font-black tracking-tight text-foreground-950">
              吃瓜<span className="text-primary-500">爆网</span>
            </span>
            <span className="mt-0.5 hidden text-[11px] text-foreground-600 sm:block">全网围观，一网打尽</span>
          </span>
        </a>

        <ul className="hidden items-center gap-1 md:flex">
          {NAV_LINKS.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="rounded-md px-3 py-2 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 hover:text-primary-600 whitespace-nowrap"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <span className="hidden items-center gap-1.5 rounded-full border border-background-200 bg-background-100 px-3 py-1.5 text-xs font-medium text-foreground-700 lg:flex">
            <span className={`h-2 w-2 rounded-full ${live ? "bg-primary-500" : "bg-accent-500"}`}></span>
            实时围观中
          </span>
          <a
            href="#feed"
            className="hidden whitespace-nowrap items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>去追热点
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 hover:bg-background-100 md:hidden"
          >
            <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`} aria-hidden="true"></i>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 md:hidden">
          <ul className="flex flex-col gap-1 pt-2">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setMenuOpen(false)}
                  className="flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100"
                >
                  {l.label}
                  <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true"></i>
                </a>
              </li>
            ))}
            <li className="pt-1">
              <a
                href="#feed"
                onClick={() => setMenuOpen(false)}
                className="flex items-center justify-center rounded-md bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50"
              >
                <i className="ri-arrow-right-line mr-1.5" aria-hidden="true"></i>去追热点
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}